// src/services/api-auth.js - Auth only
import { apiRequest } from "./api-core";

// Token management
const getToken = () => {
  return (
    localStorage.getItem("admin_token") || localStorage.getItem("user_token")
  );
};

const setToken = (token, isAdmin = false) => {
  const key = isAdmin ? "admin_token" : "user_token";
  localStorage.setItem(key, token);
};

const removeToken = () => {
  localStorage.removeItem("admin_token");
  localStorage.removeItem("user_token");
};

// Auth API with enhanced security
export const authAPI = {
  login: async (email, password, isAdmin = false) => {
    const formData = new URLSearchParams();
    formData.append("username", email);
    formData.append("password", password);

    const response = await apiRequest("/auth/token", {
      method: "POST",
      body: formData,
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    });

    // Store token based on user type
    if (response.access_token) {
      setToken(response.access_token, isAdmin);
    }

    return response;
  },

  logout: () => {
    removeToken();
    return apiRequest("/auth/logout", {
      method: "POST",
    });
  },

  getCurrentUser: () => {
    return apiRequest("/auth/me");
  },

  refreshToken: () => {
    const refreshToken = localStorage.getItem("refresh_token");
    if (!refreshToken) {
      throw new Error("No refresh token available");
    }

    return apiRequest("/auth/refresh-token", {
      method: "POST",
      body: JSON.stringify({ refresh_token: refreshToken }),
    });
  },

  register: (userData) => {
    return apiRequest("/auth/register", {
      method: "POST",
      body: JSON.stringify(userData),
    });
  },

  changePassword: (currentPassword, newPassword) => {
    return apiRequest("/auth/me/change-password", {
      method: "POST",
      body: JSON.stringify({
        current_password: currentPassword,
        new_password: newPassword,
      }),
    });
  },

  checkEmailExists: (email) => {
    return apiRequest(`/auth/check-email/${email}`);
  },
};

// Export token management functions
export { getToken, setToken, removeToken };
